/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { State } from './state';
import { Stage } from './stage';
import { User } from './user';
import { Client } from './client';
import { Tag } from './tag';
import { PresetValue } from './preset-value';

export class PreferenceRequest {
  ID: string;
  NAME: string;
  SORT: boolean;
  ORDER: string;
  STATE: State[];
  STAGE: Stage[];
  ASSIGNEE: User[];
  PROCESSOR: User[];
  RESEARCH_ANALYST: User[];
  FINANCIAL_ANALYST: User[];
  SENIOR_ANALYST: User[];
  BANK: Client[];
  DELAYED_TYPE: string;
  SIZE: number;
  TAGS: Tag[];
  SLIDER_VALUE: number;
  EQUIPMENT_PROCESSOR: User[];
  EQUIPMENT_RESEARCH_ANALYST: User[];
  EQUIPMENT_APPRAISER: User[];
  EQUIPMENT_REVIEWER: User[];
  SHOW_RESEARCHED: boolean;
  SHOW_SPREADED: boolean;
  MISC: PresetValue[];

  // Helpers
  active = false;

  static parse(json: any): PreferenceRequest {
    if (json) {
      const f = new PreferenceRequest();

      f.ID = json.ID;
      f.NAME = json.NAME;
      f.SORT = json.SORT;
      f.ORDER = json.ORDER;
      f.STATE = State.parseArray(json.STATE);
      f.STAGE = Stage.parseArray(json.STAGE);
      f.ASSIGNEE = User.parseArray(json.ASSIGNEE);
      f.PROCESSOR = User.parseArray(json.PROCESSOR);
      f.RESEARCH_ANALYST = User.parseArray(json.RESEARCH_ANALYST);
      f.FINANCIAL_ANALYST = User.parseArray(json.FINANCIAL_ANALYST);
      f.SENIOR_ANALYST = User.parseArray(json.SENIOR_ANALYST);
      f.BANK = Client.parseArray(json.BANK);
      f.DELAYED_TYPE = json.DELAYED_TYPE;
      f.SIZE = json.SIZE;
      f.TAGS = Tag.parseArray(json.TAGS);
      f.SLIDER_VALUE = json.SLIDER_VALUE;

      f.EQUIPMENT_PROCESSOR = User.parseArray(json.EQUIPMENT_PROCESSOR);
      f.EQUIPMENT_RESEARCH_ANALYST = User.parseArray(json.EQUIPMENT_RESEARCH_ANALYST);
      f.EQUIPMENT_APPRAISER = User.parseArray(json.EQUIPMENT_APPRAISER);
      f.EQUIPMENT_REVIEWER = User.parseArray(json.EQUIPMENT_REVIEWER);
      f.SHOW_RESEARCHED = json.SHOW_RESEARCHED;
      f.SHOW_SPREADED = json.SHOW_SPREADED;
      f.MISC = PresetValue.parseArray(json.MISC);

      return f;
    } else return null;
  }

  static parseArray(json: any[]): PreferenceRequest[] {
    const arr = [];

    if (json)
      for (const j of json)
        if (j)
          arr.push(PreferenceRequest.parse(j));

    return arr;
  }
}
